import React from "react";
import { DocumentContext } from "../../components/loan_tools/loan_tool";
import { removeAccessToken } from "../../services/utils";

/**
 * SaveFailedBanner — a red NOT SAVED bar shown on every loan page after a save
 * fails, until a save succeeds.
 *
 * A failed save used to be silent: the LO believed the loan was saved, then
 * reloaded (or clicked Update) and lost the edits. The edits are still in this
 * tab's memory, so the bar keeps them there and tells the LO how to save them.
 *
 * Expired session: the login must happen in a NEW tab. Logging in on this tab
 * would swap the loan for the login screen and drop the unsaved edits. The old
 * token is already dead on the server, so clearing it makes the new tab open
 * straight on the Login page. The new token it saves is shared with this tab,
 * so "Save again" here then works. This tab never re-reads the token for its
 * logged-in state, so clearing it doesn't log this tab out.
 */
export default function SaveFailedBanner() {
  const documentCtx = React.useContext(DocumentContext);
  const state = documentCtx && documentCtx[2];
  const actions = documentCtx && documentCtx[3];

  if (!state || !state.saveFailed || !actions) return null;

  function logInInNewTab() {
    removeAccessToken();
    window.open("/", "_blank");
  }

  const expired = state.saveFailed === "auth";

  return (
    <div className="save-failed-banner no-print">
      <span className="save-failed-banner-text">
        {expired
          ? "NOT SAVED: your login session expired. Your changes are still on this screen. Do NOT reload or close this tab. Log in on a new tab, then come back here and click Save Again."
          : "NOT SAVED: we couldn't reach the LANIS server. Your changes are still on this screen. Do NOT reload or close this tab. Check your internet connection, then click Save Again."}
      </span>
      {expired && (
        <button className="button save-failed-banner-button" onClick={logInInNewTab}>
          Log In (New Tab)
        </button>
      )}
      <button className="button save-failed-banner-button" onClick={() => actions.saveDocument()}>
        Save Again
      </button>
    </div>
  );
}
